import { useQuery } from '@tanstack/react-query'
import { search, searchByWikidata } from '@/services/api/search'

export const searchKeys = {
  all: ['search'] as const,
  query: (q: string) => [...searchKeys.all, 'query', q] as const,
  wikidata: (qid: string) => [...searchKeys.all, 'wikidata', qid] as const,
}

export function useSearch(query: string) {
  return useQuery({
    queryKey: searchKeys.query(query),
    queryFn: () => search(query),
    enabled: query.trim().length >= 2,
    staleTime: 1000 * 60 * 5,
  })
}

export function useSearchByWikidata(qid: string) {
  return useQuery({
    queryKey: searchKeys.wikidata(qid),
    queryFn: () => searchByWikidata(qid),
    enabled: qid.startsWith('Q') && qid.length > 1,
    staleTime: 1000 * 60 * 5,
  })
}
